<template>
  <div>
    <HomeComponent id="HOME" />
    <TestimonialsComponent id="TESTIMONIALS" />
    <ProjectsComponent id="PROJECTS" />
    <AboutMeComponent id="ABOUT_ME" />
    <AqComponent id="AQ" />
    <MethodologyComponent id="METHODOLOGY" />
    <ContactComponent id="CONTACT" />
    <FooterComponent id="FOOTER" />

    <v-dialog v-model="dialog" max-width="900">
      <v-card v-if="selectedImage">
        <v-img :src="selectedImage.image" height="500"></v-img>
        <v-card-title class="text-h5">{{ selectedImage.title }}</v-card-title>
        <v-card-subtitle>{{ selectedImage.category }}</v-card-subtitle>
        <v-card-text>{{ selectedImage.description }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="dialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import HomeComponent from './HomeComponent.vue';
import TestimonialsComponent from './TestimonialsComponent.vue';
import AboutMeComponent from './AboutMeComponent.vue';
import ContactComponent from './ContactComponent.vue';
import FooterComponent from './FooterComponent.vue';
import MethodologyComponent from './MethodologyComponent.vue';
import AqComponent from './AqComponent.vue';
import ProjectsComponent from './ProjectsComponent.vue';

import { scrollService } from '@/services/scrollService';

export default defineComponent({
  name: 'MainComponent',
  components: {
    HomeComponent,
    TestimonialsComponent,
    AboutMeComponent,
    ContactComponent,
    FooterComponent,
    MethodologyComponent,
    AqComponent,
    ProjectsComponent
  },
  data() {
    return {
      dialog: false,
      selectedImage: null as any,
      heroImage: 'https://images.unsplash.com/photo-1516035069371-29a1b244cc32?ixlib=rb-1.2.1&auto=format&fit=crop&w=1600&q=80',
      drawer: false,
      notifications: false,
      sound: false,
      widgets: false
    };
  },
  methods: {
    scrollToSection(section: string): void {
      scrollService.scrollToSection(section);
    }

  }
});
</script>